module.exports = __webpack_public_path__ + "files/28b88e9889f745d39d957367a4629cfd.png";